module.exports = require("regenerator-runtime");



/** WEBPACK FOOTER **
 ** ./~/babel-runtime/regenerator/index.js
 **/